import React from 'react';
import { NumberField } from 'react-admin';

export const BRLNumberField = (props) => <NumberField textAlign='right' locales='pt-BR' {...props} />;
